import chroma from 'chroma-js';

import { timeViewLabels } from '../../CADashboard/VulnMetrics/state';
import { getChartLegendColor } from '../../helper';
import { Severity } from '../../types';

export enum ChartColorMode {
  Labels,
  Scale,
}

export function getChartData(
  labels: string[],
  tooltips: string[],
  datasets: number[][],
  severityFilters: string[],
  colorMode: ChartColorMode = ChartColorMode.Labels,
  overrideColors?: string[],
) {
  let colors: string[] = [];
  const hoverBorderColors: string[] = [];
  const updatedLabels: string[] = [];

  labels.forEach((label) => {
    // TODO: update the new an reopened labels and push to updatedLabels array
    switch (label.toLowerCase()) {
      case 'active':
        updatedLabels.push('Active');
        break;
      case 'new':
        updatedLabels.push('New (Last Scan)');
        break;
      case 'reopened':
        updatedLabels.push('Reopened (Last Scan)');
        break;
      case 'fixed':
        updatedLabels.push('Fixed');
        break;
      case 'ignored':
        updatedLabels.push('Ignored');
        break;
      default:
        updatedLabels.push(label);
    }
  });

  if (overrideColors && overrideColors.length > 0) {
    colors = overrideColors;
  } else {
    if (colorMode === ChartColorMode.Labels) {
      labels.forEach((label) => {
        let color = getChartLegendColor(Severity.All);
        severityFilters.includes(label)
          ? (color = getChartLegendColor(label))
          : (color = getChartLegendColor(Severity.All));

        timeViewLabels.includes(label)
          ? (color = getChartLegendColor(label))
          : (color = color);

        colors.push(color);
      });
    } else {
      colors = chroma
        .scale([
          getChartLegendColor(Severity.Urgent),
          getChartLegendColor(Severity.Critical),
          getChartLegendColor(Severity.Serious),
          getChartLegendColor(Severity.Medium),
          getChartLegendColor(Severity.Minimal),
        ])
        .mode('lch')
        .colors(labels.length);
    }
  }

  colors.forEach((color) => {
    hoverBorderColors.push(chroma(color).darken(2));
  });

  let chart1 = (canvas) => {
    // let ctx = canvas.getContext("2d");

    let temp_datasets: any[] = [];
    for (let index = 0; index < datasets.length; index++) {
      let data_config = {
        label: tooltips[index],
        fill: true,
        backgroundColor: overrideColors ? colors[index] : colors,
        hoverBorderColor: overrideColors
          ? hoverBorderColors[index]
          : hoverBorderColors,
        data: datasets[index],
        scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: true,
            ticks: {
              beginAtZero: true,
            },
          },
        },
      };
      temp_datasets.push(data_config);
    }

    return {
      labels: updatedLabels,
      datasets: temp_datasets,
    };
  };

  return chart1;
}
